import { merge } from 'lodash-es';
import {
    MOCK_SMALL_CARD_COMPANY,
    MOCK_SMALL_CARD_COMPANY_TRANSLATES,
    MOCK_SMALL_CARD_COMPANY_TRANSLATES_CARD,
    MOCK_SMALL_CARD_COMPANY_TRANSLATES_RATE,
} from '@core/components/small-card/mocks.js';

export const Figma = 'https://www.figma.com/design/WMgMXjaHDsQVIEz1R8DV9C/Trust-Center-%7C-Compliance-subpage-logos?node-id=360-4460';

export const Default = {
    name: 'Default',
    args: merge({}, {
        titleTag: 'h2',
        isCompanyLayout: false,
        isRowLayout: false,
        isRateLayout: false,

        cards: Array.from({ length: 12 }).map((_, i) => ({
            ...MOCK_SMALL_CARD_COMPANY,
            to: i % 3 === 0 ? '#' : null,
            icon: '149',
            iconVariant: true,
            logo: '@71003d4ee3c6ac84146db1bf58873776',
            image: '@3ebd5147cf98e12eea516427eed4aaa0',
            rate: Array.from({ length: 4 }).map((__, j) => ({ points: j + 1 })),
        })),

        link: { to: '#' },
        downloadFileArr: [{ link: '#' }],
        columns: 4,
    }, {
        ...MOCK_SMALL_CARD_COMPANY_TRANSLATES,
        link: { text: 'Learn more' },

        cards: Array.from({ length: 12 }).map(() => ({
            ...MOCK_SMALL_CARD_COMPANY_TRANSLATES_CARD,
            iconAlt: 'Icon Title',
            logoAlt: 'Logo Alt',
            imageAlt: 'Image Alt',
            ...MOCK_SMALL_CARD_COMPANY_TRANSLATES_RATE,
        })),

        downloadFileArr: [
            {
                desc: 'PDF, 0.9 MB',
                title: 'Security at Acronis',
            },
        ],
    }),
};

export const TextOnly = {
    args: {
        titleTag: 'h2',
        columns: 3,
        title: 'Partner benefits',
        lead: 'As you grow your partnership with Acronis, you’ll unlock additional perks.',
        cards: Array.from({ length: 3 }).map(() => ({
            title: 'Backup as a Service',
            text: 'Acronis provides #1 hybrid cloud backup for any virtual, physical, and cloud environment.',
        })),
    },
};

export const Bullets = {
    args: {
        titleTag: 'h2',
        columns: 2,
        title: 'What’s included',
        cards: Array.from({ length: 2 }).map(() => ({
            title: 'Advanced Backup',
            list: [
                'Continuous data protection',
                'Microsoft 365 &amp; Google Workspace backup',
                'Off-host data processing',
                '<a href="#">Learn more about coverage</a>',
            ],
        })),
    },
};

export const Icon = {
    args: merge({}, {
        titleTag: 'h2',
        isCompanyLayout: false,
        isRowLayout: false,
        isRateLayout: false,

        cards: Array.from({ length: 8 }).map((_, i) => ({
            ...MOCK_SMALL_CARD_COMPANY,
            company: null,
            labels: null,
            to: i % 3 === 0 ? '#' : null,
            icon: (76 + i).toString(),
        })),
        columns: 4,
    }, {
        ...MOCK_SMALL_CARD_COMPANY_TRANSLATES_CARD,
        title: 'Partner benefits',

        cards: Array.from({ length: 8 }).map(() => ({
            ...MOCK_SMALL_CARD_COMPANY_TRANSLATES_CARD,
            company: null,
            labels: null,
        })),
    }),
};

export const Image = {
    args: {
        titleTag: 'h2',
        isCompanyLayout: false,
        isRowLayout: false,
        isRateLayout: false,
        title: 'Partner benefits',
        cards: merge([], Array.from({ length: 8 }).map((_, i) => ({
            to: i % 3 === 0 ? '#' : null,
            image: '/images/small-card/card-01',
        })), Array.from({ length: 8 }).map(() => ({
            title: 'Backup as a Service',
            text: '#1 hybrid cloud BaaS for any virtual, physical, and cloud environment',
            imageAlt: 'Alt',
        }))),
        columns: 4,
    },
};

export const Logo = {
    args: {
        titleTag: 'h2',
        isCompanyLayout: false,
        isRowLayout: false,
        isRateLayout: false,
        title: 'Partner benefits',
        cards: merge([], Array.from({ length: 8 }).map((_, i) => ({
            to: i % 3 === 0 ? '#' : null,
            logo: '/images/logo/microsoft',
        })), Array.from({ length: 8 }).map(() => ({
            title: 'Backup as a Service',
            text: '#1 hybrid cloud BaaS for any virtual, physical, and cloud environment',
        }))),
        columns: 4,
    },
};

export const Link = {
    args: {
        titleTag: 'h2',
        columns: 4,
        title: 'Services',
        lead: 'Get the most out of Acronis with our professional services.',
        cards: Array.from({ length: 4 }).map(() => ({
            title: 'Deployment services',
            text: 'Fast, reliable onboarding delivered by Acronis experts.',
            link: { text: 'Read more', to: '#' },
        })),
    },
};

export const PrimaryCta = {
    args: {
        titleTag: 'h2',
        columns: 3,
        title: 'Services',
        lead: 'Get the most out of Acronis with our professional services.',
        cards: Array.from({ length: 3 }).map(() => ({
            title: 'Deployment services',
            text: 'Fast, reliable onboarding delivered by Acronis experts.',
            buttons: [{ text: 'Read more', type: 'main', glyph: 'arrow', glyphPosition: 'right', to: '#' }],
        })),
    },
};

export const CardLink = {
    args: {
        titleTag: 'h2',
        columns: 3,
        title: 'Services',
        cards: Array.from({ length: 3 }).map(() => ({
            to: '#',
            title: 'Managed services',
            text: 'The entire card is clickable and links to the service page.',
        })),
    },
};

export const Rate = {
    args: merge({}, {
        titleTag: 'h2',
        link: { to: '#' },
        isRowLayout: false,
        isRateLayout: true,
        isCompanyLayout: false,

        cards: Array.from({ length: 4 }).map((_, i) => ({
            rate: Array.from({ length: 4 }).map(() => ({ points: i + 2 })),
        })),
        columns: 4,
        ignoreCardsLimit: true,
    }, {
        ...MOCK_SMALL_CARD_COMPANY_TRANSLATES,
        link: { text: 'Learn more' },

        cards: [
            {
                title: 'Registered',
                text: 'Start by unlocking immediate discounts, training, and solution and technical support',
                ...MOCK_SMALL_CARD_COMPANY_TRANSLATES_RATE,
            },
            {
                title: 'Authorized',
                text: `All of the benefits of a Registered Partner plus deeper discounts, marketing automation tools,
                        a dedicated partner account manager, and more`,
                ...MOCK_SMALL_CARD_COMPANY_TRANSLATES_RATE,
            },
            {
                title: 'Gold',
                text: `All of the benefits of an Authorized Partner, with bigger discounts, virtual credits,
                        access to the MDF program, sports benefits, and more`,
                ...MOCK_SMALL_CARD_COMPANY_TRANSLATES_RATE,
            },
            {
                title: 'Platinum',
                text: 'Full-service from top to bottom with the best discounts, enhanced support, and a dedicated team',
                ...MOCK_SMALL_CARD_COMPANY_TRANSLATES_RATE,
            },
        ],
    }),
};

export const Company = {
    args: merge({}, {
        titleTag: 'h2',
        link: { to: '#' },
        isCompanyLayout: true,
        isRowLayout: false,
        isRateLayout: false,
        cards: Array.from({ length: 4 }).map(() => (MOCK_SMALL_CARD_COMPANY)),
        columns: 4,
    }, {
        ...MOCK_SMALL_CARD_COMPANY_TRANSLATES,
        link: { text: 'Learn more' },

        cards: Array.from({ length: 4 }).map(() => ({
            ...MOCK_SMALL_CARD_COMPANY_TRANSLATES_CARD,
            title: 'Backup as a Service',
            text: '#1 hybrid cloud BaaS for any virtual, physical, and cloud environment',
        })),
    }),
};

export const Flip = {
    args: {
        title: 'Certifications & compliance',
        lead: 'Hover to preview on desktop, click or tap a card to reveal the resources on the back.',
        theme: 'light',
        ignoreCardsLimit: true,
        cards: Array.from({ length: 3 }).map((_, i) => {
            const filesOnBack = i === 1;
            const hasFiles = i !== 2;
            const flipOn = [[], ['clickCard'], ['hover']][i];
            const flipDirection = ['right', 'up', 'left'][i];
            const links = Array.from({ length: 4 }, (__, k) => ({
                to: '#',
                desc: '2.4 MB',
                title: 'Acronis_BaaS_M365_Partner_Datasheet.pdf',
                ...(k === 3 ? { glyph: 'i-arrow-down-circled-o--32' } : {}),
                ...(k === 3 ? { glyphDownload: 'i-arrow-right--16' } : {}),
            }));
            const list = [
                `The provision and maintenance in operational condition of physical sites for hosting the hardware
                infrastructure of the information system used to process the Personal Health Data.`,
                `The provision and maintenance in operational condition of the hardware infrastructure
                of the information system used to process the Personal Health Data.`,
                `The provision and maintenance in operational condition of the virtual infrastructure
                of the information system used to process the Personal Health Data.`,
                `The provision and maintenance in operational condition of the platform
                for hosting information system applications.`,
                'The management and operation of the information system containing the Personal Health Data.',
                'Backing up Personal Health Data.',
            ];

            return {
                front: {
                    logo: '@8145c145b71a98fd4dfdd7102e453396',
                    logoAlt: 'Microsoft',
                    labels: [
                        { text: 'Label', glyph: 'i-cp-used--16' },
                        { text: 'Label', variant: 'success', glyph: 'i-cp-used--16' },
                    ],
                    title: 'Acronis Cyber Cloud services',
                    text: [
                        `Independent third-party HDS certification confirms that Acronis applies technical and governance measures
                        under French law to protect Personal Health Data and ensure its confidentiality, integrity and availability.`,
                        `This card flips on <u>${flipOn.join(', ') || 'trigger click only'}</u>
                        with a <b>${flipDirection}</b> animation direction.`,
                    ],
                    ...(hasFiles && !filesOnBack ? { links } : {}),
                    trigger: { text: 'View more info', glyph: 'i-move--16' },
                },
                back: {
                    trigger: { text: 'Back', glyph: 'arrow-left' },
                    title: 'Microsoft Resources',
                    text: 'The following activities are included in the certification scope:',
                    list: filesOnBack ? list.slice(0, 2) : list,
                    ...(hasFiles && filesOnBack ? { links } : {}),
                    buttons: [
                        {
                            to: '#',
                            type: 'main',
                            glyph: 'download-arrow',
                            glyphPosition: 'right',
                            text: 'Download all resources',
                        },
                    ],
                },
                flipOn,
                flipDirection,
            };
        }),
        columns: 2,
    },
};
